import * as universal from "../../../src/routes/app/agenda/+page.js";
export { universal };
export { default as component } from "../../../src/routes/app/agenda/+page.svelte";
export const has_server_load = true;